import moment from 'moment';
import { mount, ReactWrapper } from 'enzyme';
import type { FilterOption } from '../components/downloads/Filter.d';
import { COUNTRIES } from './constants';

// Should use Suspense integrations like Relay
export function wrapPromise<T>(promise: Promise<T>): { read(): T | undefined } {
  let status = 'pending';
  let result: T;
  const suspender = promise.then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    }
  );
  return {
    // eslint-disable-next-line consistent-return
    read() {
      switch (status) {
        case 'pending':
          // eslint-disable-next-line @typescript-eslint/no-throw-literal
          throw suspender;
        case 'error':
          // console.assert(false);
          // eslint-disable-next-line @typescript-eslint/no-throw-literal
          throw result;
        case 'success':
          return result;
      }
    },
  };
}

interface IOptionDatum {
  children: string;
  key: string;
  value: string;
}

// Panic if select does not have popupElement
export function getJestWrapperOptions(select: ReactWrapper): IOptionDatum[] {
  return mount(
    select
      .findWhere((node) => node.prop('popupElement'))
      .first()
      .prop('popupElement')
  ).prop('options');
}

export const generateMonthList = (earliestMonth: string, latestMonth?: string): FilterOption[] => {
  const currentDate = moment(latestMonth);

  const monthList = [
    {
      label: 'All months',
      value: 'all',
    },
  ];

  while (currentDate.isAfter(moment(earliestMonth)) && currentDate.diff(moment(earliestMonth), 'month') >= 0) {
    monthList.push({
      label: currentDate.format('MMM YYYY'),
      value: currentDate.format('YYYY-MM'),
    });
    currentDate.subtract(1, 'month');
  }

  return monthList;
};

export const isSingapore = process.env.REACT_APP_REGION === COUNTRIES.SG;
export const isMalaysia = process.env.REACT_APP_REGION === COUNTRIES.MY;
export const isAustralia = process.env.REACT_APP_REGION === COUNTRIES.AU;
export const isHongKong = process.env.REACT_APP_REGION === COUNTRIES.HK;
